import script from "./SubmitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitForm.vue?vue&type=script&setup=true&lang=js"

import "./SubmitForm.vue?vue&type=style&index=0&id=537488ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537488ab"]])

export default __exports__